import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import "@angular/compiler";
import { SentryService } from "./app/shared/sentry/sentry.service";
import * as moment from "moment";
import { BrowserStorageUtil } from "./app/shared/browser.storage.util";

// Declare global variables
declare var AppStorageUtil: any;
declare var browserWindow: any;
declare var isLocalStorageAvailable: any;
declare var temporaryStorage: any;
declare var temporarySessionStorage: any;

if (environment.production) {
  enableProdMode();
}
AppStorageUtil = BrowserStorageUtil
browserWindow = window
isLocalStorageAvailable = AppStorageUtil.isLocalStorageAvailable();

(window as any).temporaryStorage =  {
  storage: {},
  setItem(key: string, value: any): void {
    this.storage[key]=value;
  },

  getItem(key: string): any | undefined {
    if(key in this.storage){
      return this.storage[key];
    }
    return null;
  }
};
(window as any).temporarySessionStorage = Object.assign({}, (window as any).temporaryStorage);

// Keep local references
temporaryStorage = (window as any).temporaryStorage;
temporarySessionStorage = (window as any).temporarySessionStorage;

checkLoginTokenExpiry();

// Call the async function to start the initialization
initializeApp();

async function initializeApp() {
  try {
    let isSentryEnabled = false; // Default value

    try {
      const featureFlagResponse = await fetch(
        environment.APIEndPoint + "FeatureFlag?key=isSentryEnabled"
      );
      const featureFlagText = await featureFlagResponse.text();
      const featureFlag = JSON.parse(featureFlagText);
      isSentryEnabled = featureFlag && featureFlag["isFeatureOn"];
    } catch (error) {
      console.warn("Failed to fetch Sentry feature flag:", error);
    }

    if (isSentryEnabled) {
      console.log("Sentry will be initialized for ",environment.environmentName);
      const sentryService = new SentryService();
      sentryService.initSentry(
        environment.Sentry.DSN,
        environment.environmentName,
        environment.Sentry.ReplaysSessionSampleRate,
        environment.Sentry.ReplaysOnErrorSampleRate
      );

      sentryService.setLoggedUserDetails();
    }
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .then((moduleRef) => {
      })
      .catch((err) => console.log(err));
  } catch (error) {
    console.error("Error initializing app:", error);
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.log(err));
  }
}

function logoutAndRedirectToLogin() {
  console.log("Logging out and redirecting to login page");
  browserWindow.location.href="/logout";
}

function checkLoginTokenExpiry() {
  const loginExpiryDate = AppStorageUtil.getLoginSessionEndTime();

  if (loginExpiryDate && !isNaN(Number(loginExpiryDate))) {
    const loginExpiryMoment = moment.unix(Number(loginExpiryDate));
    const loginMoment = loginExpiryMoment.clone().subtract(24, "hours");
    const currentMoment = moment();
    const hoursSinceLogin = moment
      .duration(currentMoment.diff(loginMoment))
      .asHours();
    console.log("loginExpiryMoment", loginExpiryMoment);
    if (hoursSinceLogin < 0 || hoursSinceLogin >= 24) {
      console.log(
        "%cLogin was more than 24 hours ago. Redirecting to login page.",
        "color: red; font-size: 10px;"
      );
      return false;
    }
    return true;
  } else {
    return false;
  }
}
